'use client';

import { ChatOverlay } from '@/features/chat/components/organisms/ChatOverlay';
import { useChatStore } from '@/features/chat/stores/chatStore';
import { PageHeader } from '@/features/product/components/organisms/ProductPageHeader';
import ProductTable from '@/features/product/components/organisms/ProductTable';
import { SideBanner } from '@/features/product/components/organisms/SideBanner';
import { Suspense } from 'react';

export default function ProductsPage() {
  const { isOverlayOpen, toggleOverlay } = useChatStore();

  return (
    <div className="container">
      <PageHeader />
      <div className="relative min-h-[500px]">
        <SideBanner position="left" />
        <Suspense fallback={
          <div className="animate-pulse">
            <div className="h-32 bg-gray-200 rounded-lg mb-4" />
            <div className="space-y-3">
              {[...Array(10)].map((_, i) => (
                <div key={i} className="h-12 bg-gray-200 rounded" />
              ))}
            </div>
          </div>
        }>
          <ProductTable />
        </Suspense>
        <SideBanner position="right" />
      </div>

      {/* EZTalk */}
      <ChatOverlay
        isOpen={isOverlayOpen}
        onClose={toggleOverlay}
      />
    </div >
  );
}
